export enum eHoaDonHinhThuc {
  HOA_DON_GOC = 1,
  HOA_DON_THAY_THE = 2,
  HOA_DON_DIEU_CHINH = 3,
  HOA_DON_BI_DIEU_CHINH = 4,
  HOA_DON_DA_HUY_NOI_BO = 5,
  HOA_DON_BI_THAY_THE = 6,
  HOA_DON_DA_THONG_BAO_GIAI_TRINH = 7,
  HOA_DONT_DA_TBSS_HUY = 9,
  DA_GUI_TBSS_THAY_THE = 10,
}
